const config = {
  "putFunctionUrl": "https://zqufwh712f.execute-api.us-east-1.amazonaws.com/prod/putsecret",
  "getFunctionUrl": "https://5igdu7cb59.execute-api.us-east-1.amazonaws.com/prod/getsecret",
  "contactFormUrl": "https://km0szmniu3.execute-api.us-east-1.amazonaws.com/prod/contactform"
}
export default config
